import {useContext} from 'react'
import { GlobalContext } from '../store/GlobalStore';

const useGlobalContext = () => {
    const ctx = useContext(GlobalContext)
    return ctx
}

export default useGlobalContext